import { HOURS_WORDS, MINUTES_WORDS, TIME_DATE_PARAMS } from '../UsersTable.contstants';

export function formatTime(disconnectTime) {
  if (!disconnectTime) return 'неизвестно';

  const now = new Date();
  const diffMs = now - new Date(disconnectTime);
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);

  if (diffMinutes < 60) {
    return `Был в сети ${diffMinutes} ${declineWord(diffMinutes, MINUTES_WORDS)} назад`;
  }

  if (diffHours < 24) {
    return `Был в сети ${diffHours} ${declineWord(diffHours, HOURS_WORDS)} назад`;
  }

  const formattedDisconnectTime = new Date(disconnectTime).toLocaleDateString('ru-RU', TIME_DATE_PARAMS);

  return `Был в сети ${formattedDisconnectTime}`;
}

function declineWord(number, words) {
  switch (number) {
    case 1:
      return words[0];

    case 2:
    case 3:
    case 4:
      return words[1];

    default:
      return words[2];
  }
}
